import { makeStyles } from "@material-ui/core/styles";
import { Link, Typography } from "@material-ui/core";
import { Wrapper } from "../base/Wrapper";
import TitleBar from "../TitleBar";

const useStyles = makeStyles((theme) => ({
  root: {
    maxWidth: "40rem",
    margin: "0 10vw",
    padding: "10vh 0",
  },
}));

export default function Impressum({ isDesktop }) {
  const classes = useStyles();

  return (
    <>
      {!isDesktop && <TitleBar title="Impressum" navigateTo="/profile" colorPrimary />}
      <Wrapper className={isDesktop ? classes.root : null}>
        <Typography variant="h6" component="h2" gutterBottom>
          Herausgeber
        </Typography>
        <Typography variant="body2" gutterBottom>
          Duale Hochschule Baden-Württemberg
          <br />
          Präsident: Professor Arnold van Zyl
        </Typography>
        <Typography variant="body2" gutterBottom>
          Friedrichstraße 14
          <br />
          70174 Stuttgart
        </Typography>
        <Typography variant="body2" gutterBottom>
          Telefon 0711 / 320 660-0
          <br />
          Telefax 0711 / 320 660-66
          <br />
          poststelle(at)dhbw.de
          <br />
          <Link href="https://www.dhbw.de/">www.dhbw.de</Link>
        </Typography>
        <Typography variant="h6" component="h2" gutterBottom style={{ marginTop: "16px" }}>
          Redaktionelle Verantwortlichkeiten
        </Typography>
        <Typography variant="body2" gutterBottom>
          Benjamin Hötzel
          <br />
          Email:{" "}
          <Link href="mailto:benjamin.hoetzel@mosbach.dhbw.de">
            benjamin.hoetzel(at)mosbach.dhbw.de
          </Link>
          <br />
          Telefon: <Link href="tel:+496261939441">06261 / 939-441</Link>
          <br />
        </Typography>
        <Typography variant="body2" gutterBottom>
          Die Duale Hochschule Baden-Württemberg ist eine rechtsfähige Körperschaft des öffentlichen
          Rechts. Sie wird gesetzlich vertreten durch den Präsidenten der Dualen Hochschule
          Baden-Württemberg, Herrn Professor Arnold van Zyl. Der Hochschulstandort Mosbach wird
          durch die Rektorin oder den Rektor gesetzlich vertreten.
        </Typography>
      </Wrapper>
    </>
  );
}
